import * as React from 'react';
import { getClassName,getResName } from './Restrictions';
import {  Box, Menu, Table, TableCell, TableContainer, 
  TableHead, TableRow, TableBody, Popover, Tooltip } from '@mui/material';
import { isEmptyObj } from '../../app/util';
export default function RoomTypeRestrictionsList(props) {
  let houseItems = props.chipArrAll;
  let {restrictionHouseData, roomTypeRestdata} = props; //props.roomTypeRestdata;  we need to open this when we nee dto show Room type restrictions

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

 
  let rmTypeResTable =  roomTypeRestdata.map((item, k) => {
    let chipArray = [];
    if (item['min_los'] <= 1) {
        delete item['min_los']
    }
    if (item['max_los'] <= 1) {
        delete item['max_los']
    }
    if(item.close === false){
      delete item.close;
    }
    if(item.cta === false){
      delete item.cta;
    }
    if(item.ctd === false){
      delete item.ctd;
    }
    let keys = Object.keys(item).filter(i => i !== "stay_date" && 
    i !== "room_type" && i !== "updatedEntry" && i !== "asof_date" && i !== "exceptions")
    const hasExceptions = item.exceptions && Object.keys(item.exceptions).length > 0;

    keys.forEach((key, index) => {
      let exceptionsDisplay="";

        let resName = key.toUpperCase();
        let classStyle = getClassName(resName);
        let itemNameDetails = getResName(key,item[key]);
        resName = itemNameDetails.resName;
        const displayName = (hasExceptions && !isEmptyObj(item.exceptions[key])) ? `${resName}*` : resName;

        if(hasExceptions && !isEmptyObj(item.exceptions[key])){
            Object.keys(item.exceptions[key]).forEach(exception=>{
              exceptionsDisplay+=exception+": " + item.exceptions[key][exception] +" ";
            })
          
          }
        chipArray.push(
          // <Chip label={itemName} size="small" className={classStyle} sx={{marginRight:"5px !important", minWidth: "45px !important", height: "25px !important" }} />
          <Tooltip title={exceptionsDisplay}>
            <div className={"chip " + classStyle}>{displayName}</div>
          </Tooltip>
        )
      

    })
    return <>
      <TableRow
        sx={{ '&:first-child td, &:first-child th': { border: 0, pt: 1 }, '&:last-child td, &:last-child th': { border: 0 }, '& td, & th': { border: 0, pt: .6, pb: 0, fontSize: 12, color: "#333333" } }}
      >
        <TableCell component="th" scope="row">
          {item.room_type}
        </TableCell> <TableCell component="th" scope="row">
          {item.room_type}
        </TableCell> <TableCell component="th" scope="row">
          {chipArray}
        </TableCell>
      </TableRow>

    </>
  });

  const [arrowTop, setArrowTop] = React.useState("50%");

  React.useEffect(() => {
    if (!anchorEl) return;

    setTimeout(() => {
      const menuElement = document.querySelector('.rateplan-box');
      const menuHeight = menuElement?.offsetHeight || 200;
      const anchorRect = anchorEl.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const spaceBelow = windowHeight - anchorRect.top;
      const spaceAbove = anchorRect.top;
      const diff = menuHeight / 2 - spaceBelow;

      let newArrowTop = "50%";

      // If the popover is near the top, move the arrow up
      if (spaceAbove < menuHeight / 2) {
        newArrowTop = `${Math.max(25, (spaceBelow / menuHeight) * 100)}%`;
      }
      // If the popover is near the bottom, move the arrow down
      else if (spaceBelow < menuHeight / 2) {
        newArrowTop = diff > 10 ? "66%" : diff > 5 ? "50%" : "50%";
      }

      console.log("newArrowTop", newArrowTop);
      setArrowTop(newArrowTop);
    }, 0);
  }, [anchorEl, open]);

  return (
    <div className='restrictions-details' style={{marginLeft:"4px"}}>
      <div
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        //onClick={handleClick}
        onMouseOver={handleClick}
        // onMouseLeave={handleClose}
        style={{cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#606060" viewBox="0 0 256 256"><path d="M144,128a16,16,0,1,1-16-16A16,16,0,0,1,144,128ZM60,112a16,16,0,1,0,16,16A16,16,0,0,0,60,112Zm136,0a16,16,0,1,0,16,16A16,16,0,0,0,196,112Z"></path></svg>      
      </div>
      <Popover
        className='restrictions-details'
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          sx: {
            ml: "-12px",
            width: "max-content",
            position: 'relative',
            overflow: 'visible',
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              right: '-11px', // Adjust position as needed
              top: arrowTop,
              width: 0,
              height: 0,
              borderTop: '9px solid transparent',
              borderBottom: '9px solid transparent',
              borderLeft: '11px solid #F8F9FA', // Triangle color
              transform: 'translateY(-50%)',
              filter: 'drop-shadow(-5px -4px 16px rgba(0, 0, 0, 0.9))', // Adds soft shadow
              zIndex: 1
            }
          },
        }}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
      >

        <Box className='restriction-box otb-restrictions-tooltip'>
          <Box className='restriction-box-title'>Restrictions</Box>
          <Box sx={{ m: .5, overflow: "auto", maxHeight: 170 }}>
            <TableContainer sx={{}}>
              <Table sx={{}}>
                <TableHead>
                  <TableRow className='restriction-table-row' sx={{ '& td, & th': { pt: .5, pb: .2, borderBottom: 1 } }}>
                    <TableCell className='table-heading' sx={{}}>Room Type	</TableCell>
                    <TableCell className='table-heading'>Room Code</TableCell>
                    <TableCell className='table-heading'>Restriction</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody sx={{ overflowX: "hidden", overflowY: "auto" }}>

                 

                  {houseItems.length>0 && ( <TableRow
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, '& td, & th': { border: 0, pt: .6, pb: .8, fontSize: 12, color: "#333333" } }}
                  >
                    <TableCell component="th" scope="row">
                      House
                    </TableCell> <TableCell component="th" scope="row">
                      House
                    </TableCell> <TableCell className='restrictions-tooltip-chips' component="th" scope="row">
                      {houseItems}
                    </TableCell>
                  </TableRow>)}
                  {
                   rmTypeResTable

                  }



                </TableBody>
              </Table></TableContainer>
          </Box>
        </Box>

      </Popover>
    </div >
  );
}